<template>
  <div class="p-6 bg-white border-t border-gray-200">
    <ValidationObserver ref="observer">
      <template #default="{ handleSubmit }">
        <NoteForm
          :content.sync="data.content"
          :disabled="creating"
          @submit="handleSubmit(create)"
          @cancel="cancel"
        />
      </template>
    </ValidationObserver>
  </div>
</template>

<script>
import NoteFormVue from '@/components/Notes/NoteForm.vue';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  mixins: [veeValidateErrorsMixin],

  components: {
    NoteForm: NoteFormVue,
  },

  props: {
    orderItemId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      creating: false,
      data: {
        content: '',
        order_item: this.orderItemId,
      },
      errorMsg: '',
    };
  },

  methods: {
    setCreating(value) {
      this.creating = value;
      this.$emit('creating', value);
    },
    async create() {
      if (this.creating) return;

      this.setCreating(true);

      try {
        const result = await this.$store.dispatch({
          type: 'ui/notes/store',
          body: this.data,
        });

        this.$emit('created', result);
      } catch (error) {
        if (!error.response) {
          return;
        }

        const { status, data: { errors = [], message = '' } = {} } = error.response;

        if (status !== HTTP_UNPROCESSABLE_ENTITY) {
          return;
        }

        this.applyServerErrors(errors);
        this.errorMsg = message;
      } finally {
        this.setCreating(false);
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    applyServerErrors(errors) {
      this.observer = this.$refs.observer;
      this.addServerErrors(errors);
    },
  },
};
</script>
